import { render, staticRenderFns } from "./EventStaffUserChip.vue?vue&type=template&id=155c84de&scoped=true"
import script from "./EventStaffUserChip.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventStaffUserChip.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EventStaffUserChip.vue?vue&type=style&index=0&id=155c84de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155c84de",
  null
  
)

export default component.exports